module.exports = __webpack_public_path__ + "static/img/person-3.dbb3e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/person-3.png
// module id = oD33
// module chunks = 1